import { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Formik } from "formik";
import { Slide, ToastContainer, toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { noteTypesManagement } from "../../../../../../hooks/api/NoteTypesManagement";
import { DefaultLayout } from "../../../../../../layouts/Default";
import { TopNavigation } from "../../../../../../themes/Default/components/TopNavigation";
import { Button, ButtonBack } from "../../../../../../themes/Default/components/TopNavigation/components/Button";
import { Tabs } from "../../../../../../themes/Default/components/Tabs";
import { Main } from "../../../../../../themes/Default/components/Main";
import { Breadcrumps } from "../../../../../../themes/Default/components/Breadcrumps";
import { Link } from "../../../../../../themes/Default/components/Breadcrumps/components/Link";
import { Form } from "../../../../../../themes/Default/components/Form";
import { Row } from "../../../../../../themes/Default/components/Form/components/Row";
import { Field } from "../../../../../../themes/Default/components/Form/components/Row/components/Field";
import { Input } from "../../../../../../themes/Default/components/Form/components/Input";
import ColorPicker from "../../../../../../themes/Default/components/Form/components/ColorPicker/ColorPicker";

const AddNoteType = () => {
    const { t } = useTranslation("common");
    const formRef = useRef(null);
    const navigate = useNavigate();
    const [formErrors, setFormErrors] = useState([]);
    const { useAddNoteTypesMutation } = noteTypesManagement;
    const [addNoteType, { isLoading: isAddingNoteType }] = useAddNoteTypesMutation();

    const tabs = [
        { title: t('noteTypes.title'), isActive: true},
        { title: t('guardianTypes.title'), onClick: () => gotoGuardianType()},
        { title: t('municipalities.title'), onClick: () => gotoMunicipalities()},
    ];

    const gotoGuardianType = () => {
        navigate("/settings/default/guardian-types");
    };

    const gotoMunicipalities = () => {
        navigate("/settings/default/municipalities");
    };

    const onSave = () => {
        if (formRef.current) {
            formRef.current.handleSubmit();
        }
    };

    const onSaved = (values) => {
        if (values?.contactPerson === "") {
            values.contactPerson = null;
        }
        addNoteType(values).then((result) => {            
            if (result?.error) {
                setFormErrors(result?.error?.data?.error?.violations);
                toast.error(result.error.data.error.responseMessage);
            } else {
                navigate("/settings/default/note-types");
            }
        });
    };

    return (
        <DefaultLayout>
            
            <TopNavigation>
                <ButtonBack to="/settings/default/note-types" />
                <Button title={t("save")} isDisabled={isAddingNoteType} icon="fa-regular fa-floppy-disk" onClick={onSave}></Button>
            </TopNavigation>
            <Tabs tabs={tabs} />
            <Main>
                <Breadcrumps>
                    <Link title={t("settings.title")} icon="fa-gear" />
                    <Link title={t("settings.default")} />
                    <Link title={t("noteTypes.title")} />
                    <Link title={t("noteTypes.addNew")} isActive={true} />
                </Breadcrumps>
                <Formik
                        innerRef={formRef}
                        initialValues={{
                            name: ""
                        }}
                        onSubmit={onSaved}
                    >
                    {({ values, handleChange }) => (
                        <Form>
                            <Row>
                                <Field>
                                    <Input
                                        name="name"
                                        label={t("noteTypes.name")}
                                        required={true}
                                        value={values.name}
                                        onChange={handleChange}
                                        error={formErrors?.name}
                                    />
                                </Field>     
                                <Field>
                                    <ColorPicker
                                        name="color"
                                        label={t("noteTypes.color")}
                                        required={true}
                                        value={values.color}
                                        onChange={handleChange}
                                    />
                                </Field>                    
                            </Row>
                            
                        </Form>
                    )}
                </Formik>
            </Main>
        </DefaultLayout>
    );
};

export default AddNoteType;